// ============================================
// ОБРАБОТКА ФОРМ
// ============================================

// Валидация формы
function validateForm(form) {
    let isValid = true;
    const errors = [];

    // Проверка имени
    const nameInput = form.querySelector('input[name="name"]');
    if (nameInput && (!nameInput.value.trim() || nameInput.value.trim().length < 2)) {
        errors.push('Укажите ваше имя (минимум 2 символа)');
        nameInput.classList.add('error');
        isValid = false;
    } else if (nameInput) {
        nameInput.classList.remove('error');
    }

    // Проверка телефона
    const phoneInput = form.querySelector('input[name="phone"]');
    if (phoneInput) {
        const phoneValue = phoneInput.value.replace(/\D/g, '');
        if (!phoneValue || phoneValue.length < 10) {
            errors.push('Укажите корректный номер телефона (минимум 10 цифр)');
            phoneInput.classList.add('error');
            isValid = false;
        } else {
            phoneInput.classList.remove('error');
        }
    }

    // Проверка email если выбран
    const emailCheckbox = form.querySelector('input[value="email"]');
    const emailInput = form.querySelector('input[name="email"]');
    if (emailCheckbox && emailCheckbox.checked && emailInput) {
        const emailValue = emailInput.value.trim();
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        if (!emailValue) {
            errors.push('Укажите email адрес');
            emailInput.classList.add('error');
            isValid = false;
        } else if (!emailRegex.test(emailValue)) {
            errors.push('Укажите корректный email адрес');
            emailInput.classList.add('error');
            isValid = false;
        } else {
            emailInput.classList.remove('error');
        }
    }

    // Проверка согласия с политикой
    const policyCheckbox = form.querySelector('input[name="policy"]');
    if (policyCheckbox && !policyCheckbox.checked) {
        errors.push('Необходимо согласие с политикой конфиденциальности');
        policyCheckbox.closest('.calculation__form-group--checkbox').classList.add('error');
        isValid = false;
    } else if (policyCheckbox) {
        policyCheckbox.closest('.calculation__form-group--checkbox').classList.remove('error');
    }

    // Проверка выбора способа связи
    const contactCheckboxes = form.querySelectorAll('input[name="contact[]"]:checked');
    if (contactCheckboxes.length === 0) {
        errors.push('Выберите хотя бы один способ связи');
        const contactMethods = form.querySelector('.calculation__contact-methods');
        if (contactMethods) contactMethods.classList.add('error');
        isValid = false;
    } else {
        const contactMethods = form.querySelector('.calculation__contact-methods');
        if (contactMethods) contactMethods.classList.remove('error');
    }

    // Показываем ошибки
    if (errors.length > 0) {
        showFormErrors(form, errors);
    }

    return isValid;
}

// Показать ошибки формы
function showFormErrors(form, errors) {
    clearMessages(form);

    const errorDiv = document.createElement('div');
    errorDiv.className = 'form-error-message';
    errorDiv.style.cssText = `
        background: rgba(255, 56, 96, 0.1);
        border: 1px solid rgba(255, 56, 96, 0.3);
        color: #ff7a93;
        padding: 12px 15px;
        border-radius: 10px;
        font-size: 14px;
        margin-bottom: 15px;
        animation: fadeIn 0.3s ease;
    `;

    let errorHTML = '<div style="display: flex; align-items: flex-start; gap: 8px;">';
    errorHTML += '<span style="font-size: 16px; flex-shrink: 0;">⚠️</span>';
    errorHTML += '<div>';

    errors.forEach(error => {
        errorHTML += `<div style="margin-bottom: 5px;">${error}</div>`;
    });

    errorHTML += '</div></div>';
    errorDiv.innerHTML = errorHTML;

    form.prepend(errorDiv);
}

// Показать сообщение об успехе
function showSuccessMessage(form, message) {
    clearMessages(form);

    const successDiv = document.createElement('div');
    successDiv.className = 'form-success-message';
    successDiv.style.cssText = `
        background: rgba(46, 204, 113, 0.1);
        border: 1px solid rgba(46, 204, 113, 0.3);
        color: #2ecc71;
        padding: 12px 15px;
        border-radius: 10px;
        font-size: 14px;
        margin-bottom: 15px;
        animation: fadeIn 0.3s ease;
    `;

    successDiv.innerHTML = `
        <div style="display: flex; align-items: center; gap: 8px;">
            <span style="font-size: 18px;">✅</span>
            <span>${message}</span>
        </div>
    `;

    form.prepend(successDiv);

    // Автоматически скрываем через 5 секунд
    setTimeout(() => {
        successDiv.remove();
    }, 5000);
}

// Очистить сообщения
function clearMessages(form) {
    const messages = form.querySelectorAll('.form-success-message, .form-error-message');
    messages.forEach(msg => msg.remove());
}

// Очистить ошибки поля
function clearFieldError(input) {
    input.classList.remove('error');
    if (input.type === 'checkbox' && input.name === 'policy') {
        input.closest('.calculation__form-group--checkbox').classList.remove('error');
    }
}

// Маска телефона
function initPhoneMask(input) {
    input.addEventListener('input', function(e) {
        let value = this.value.replace(/\D/g, '');

        if (value.length > 0) {
            if (value[0] === '7' || value[0] === '8') {
                value = value.substring(1);
            }

            let formattedValue = '+7 ';

            if (value.length > 0) {
                formattedValue += '(' + value.substring(0, 3);
            }
            if (value.length > 3) {
                formattedValue += ') ' + value.substring(3, 6);
            }
            if (value.length > 6) {
                formattedValue += '-' + value.substring(6, 8);
            }
            if (value.length > 8) {
                formattedValue += '-' + value.substring(8, 10);
            }

            this.value = formattedValue;
        }
    });
}

// Управление полем email
function initEmailToggle(form) {
    const emailCheckbox = form.querySelector('input[value="email"]');
    const emailInput = form.querySelector('input[name="email"]');

    if (!emailCheckbox || !emailInput) return;

    const emailGroup = emailInput.closest('.calculation__form-group');

    // Инициализация
    if (emailCheckbox.checked) {
        emailGroup.style.display = 'block';
        emailInput.required = true;
    } else {
        emailGroup.style.display = 'none';
        emailInput.required = false;
    }

    emailCheckbox.addEventListener('change', function() {
        if (this.checked) {
            emailGroup.style.display = 'block';
            emailInput.required = true;
        } else {
            emailGroup.style.display = 'none';
            emailInput.required = false;
            emailInput.value = '';
        }
    });
}

// Обработка файлов
function initFileInput(form) {
    const fileInput = form.querySelector('.calculation__form-file');
    const fileText = form.querySelector('.calculation__file-text');

    if (!fileInput || !fileText) return;

    fileInput.addEventListener('change', function() {
        if (this.files.length > 0) {
            const file = this.files[0];
            const maxSize = 10 * 1024 * 1024; // 10MB

            if (file.size > maxSize) {
                showFormErrors(form, ['Файл слишком большой. Максимальный размер: 10MB']);
                this.value = '';
                fileText.textContent = 'Фото объекта или чертежи (если есть)';
            } else {
                const sizeInMB = (file.size / (1024 * 1024)).toFixed(2);
                fileText.textContent = file.name + ' (' + sizeInMB + ' MB)';
                clearMessages(form);
            }
        } else {
            fileText.textContent = 'Фото объекта или чертежи (если есть)';
        }
    });
}

// Основная функция инициализации форм
function initForms() {
    const forms = document.querySelectorAll('.calculation__form');

    if (forms.length === 0) return;

    forms.forEach((form, index) => {
        // Инициализация
        initEmailToggle(form);
        initFileInput(form);

        // Маска телефона
        const phoneInput = form.querySelector('input[name="phone"]');
        if (phoneInput) initPhoneMask(phoneInput);

        // Очистка ошибок при вводе
        form.addEventListener('input', function(e) {
            if (e.target.matches('.calculation__form-input, .calculation__form-textarea')) {
                clearFieldError(e.target);
            }
        });

        form.addEventListener('change', function(e) {
            if (e.target.matches('.calculation__contact-checkbox, .calculation__checkbox')) {
                const contactMethods = form.querySelector('.calculation__contact-methods');
                if (contactMethods) contactMethods.classList.remove('error');
                clearMessages(form);
            }
        });

        // Отправка формы
        form.addEventListener('submit', async function(e) {
            e.preventDefault();

            clearMessages(form);

            if (!validateForm(form)) {
                return;
            }

            const submitBtn = form.querySelector('button[type="submit"]');
            const originalText = submitBtn.textContent;

            // Блокируем кнопку
            submitBtn.disabled = true;
            submitBtn.textContent = 'Отправка...';

            try {
                const formData = new FormData(form);
                formData.append('action', 'send_calculation_form');

                // Добавляем nonce если он есть
                if (window.calculationForm && window.calculationForm.nonce) {
                    formData.append('nonce', window.calculationForm.nonce);
                }

                const response = await fetch(
                    window.calculationForm ? window.calculationForm.ajaxurl : '/wp-admin/admin-ajax.php',
                    {
                        method: 'POST',
                        body: formData
                    }
                );

                if (!response.ok) {
                    throw new Error('Ошибка сети: ' + response.status);
                }

                const data = await response.json();

                if (data.success) {
                    showSuccessMessage(form, data.data?.message || 'Заявка успешно отправлена! Мы свяжемся с вами в течение 30 минут.');
                    form.reset();

                    // Сбрасываем поле email
                    const emailInput = form.querySelector('input[name="email"]');
                    const emailCheckbox = form.querySelector('input[value="email"]');
                    if (emailInput && emailCheckbox) {
                        emailInput.value = '';
                        emailCheckbox.checked = false;
                        emailInput.closest('.calculation__form-group').style.display = 'none';
                        emailInput.required = false;
                    }

                    // Сбрасываем файл
                    const fileText = form.querySelector('.calculation__file-text');
                    if (fileText) {
                        fileText.textContent = 'Фото объекта или чертежи (если есть)';
                    }

                    // Сбрасываем чекбокс согласия
                    const policyCheckbox = form.querySelector('input[name="policy"]');
                    if (policyCheckbox) {
                        policyCheckbox.checked = false;
                    }
                } else {
                    showFormErrors(form, [data.data?.message || 'Ошибка при отправке']);
                }
            } catch (error) {
                console.error('Form submission error:', error);
                showFormErrors(form, ['Произошла ошибка при отправке. Пожалуйста, попробуйте еще раз.']);
            } finally {
                // Разблокируем кнопку
                submitBtn.disabled = false;
                submitBtn.textContent = originalText;
            }
        });
    });
}

// Добавьте CSS для ошибок
const errorStyles = document.createElement('style');
errorStyles.textContent = `
    .calculation__form-input.error,
    .calculation__form-textarea.error {
        border-color: #ff3860 !important;
        background: rgba(255, 56, 96, 0.05) !important;
    }

    .calculation__form-group--checkbox.error {
        background: rgba(255, 56, 96, 0.05) !important;
        border-radius: 10px;
        padding: 10px;
        margin: -5px -10px 5px -10px;
        border: 1px solid rgba(255, 56, 96, 0.3);
    }

    .calculation__contact-methods.error {
        border-color: #ff3860 !important;
        background: rgba(255, 56, 96, 0.05) !important;
    }

    @keyframes fadeIn {
        from {
            opacity: 0;
            transform: translateY(-10px);
        }
        to {
            opacity: 1;
            transform: translateY(0);
        }
    }
`;
document.head.appendChild(errorStyles);

// Инициализация при загрузке DOM
document.addEventListener('DOMContentLoaded', initForms);
